import { ReactElement, useMemo, memo } from 'react';
import { Stack, Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRepeat as RenovateIcon } from '@fortawesome/free-solid-svg-icons';

import { useAppSelector } from '~hooks/useAppSelector';
import { useTypePartnerCompany } from '~hooks/useTypePartnerCompany';
import { selectAuth } from '~store/slices/auth';
import { isOnlyReadUser, isOnlyCreatorOrder } from '~utils/user';
import { comparateDateToNow } from '~utils/commons';

import ExpirationDateInfo from '../ExpirationDateInfo';

import { IntegrationExpirationDateInfoProps } from './types';

const IntegrationExpirationDateInfo = ({
  expirationDate,
  onRenovate,
}: IntegrationExpirationDateInfoProps): ReactElement => {
  const { user } = useAppSelector(selectAuth);
  const { isCarrier } = useTypePartnerCompany();

  const isValidUser = useMemo(
    () => !isOnlyReadUser(user) && !isOnlyCreatorOrder(user),
    [user],
  );

  const hasExpired = useMemo(
    () =>
      comparateDateToNow({
        date: expirationDate,
        comparationType: 'sameOrBefore',
      }),
    [expirationDate],
  );

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <ExpirationDateInfo
        expirationDate={expirationDate}
        tooltipMessage="Integración vencida"
        comparationType="sameOrBefore"
      />

      {isCarrier && isValidUser && hasExpired && (
        <Button
          color="primary"
          variant="outlined"
          size="small"
          className="pulse"
          sx={{ fontSize: (theme) => theme.typography.pxToRem(11) }}
          startIcon={
            <FontAwesomeIcon icon={RenovateIcon} style={{ fontSize: 11 }} />
          }
          onClick={onRenovate}
        >
          Renovar
        </Button>
      )}
    </Stack>
  );
};

export default memo(IntegrationExpirationDateInfo);
